/**
 * Wave 320 · cross-component UI state.
 *
 * One job for now: track which top-level slide-over is open so other
 * floating surfaces (Housy bubble, HouseAgent mark, tour overlays) can
 * step out of the way and don't fight z-index battles with the
 * dialog the user is actually using.
 *
 * If we add more chrome (e.g. a global command palette state) it
 * lives here too — keep it tiny, no persistence.
 */
import { create } from 'zustand';

interface UiState {
  /** PrumoQueue slide-over visible. */
  prumoOpen: boolean;
  setPrumoOpen: (v: boolean) => void;
}

export const useUi = create<UiState>((set) => ({
  prumoOpen: false,
  setPrumoOpen: (v) => set({ prumoOpen: v }),
}));
